export * from './dist/ts/commonjs/parallax.directive';


// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/~/ng2-parallax/commonjs.ts